const qcRoutes = [
  // {
  //   path: '/qc/index',
  //   name: '质检管理',
  //   icon: 'iconmenuicon-xitong',
  //   children: [],
  //   component: () => import('@/views/qc/index')
  // }
  {
    path: '/qc/businessModeling',
    name: '业务建模',
    component: () => import('@/views/qc/businessModeling/index'),
    children: [
      {
        path: '/qc/newModel',
        name: '新建模型',
        component: () => import('@/views/qc/businessModeling/newModel'),
        children: [{
          path: '/qc/newModel/newModel_semanticsModule',
          name: '语义模型',
          component: () => import('@/views/qc/businessModeling/newModel_semanticsModule')
        }, {
          path: '/qc/newModel/newModel_menu',
          name: '模型菜单',
          component: () => import('@/views/qc/businessModeling/newModel_menu')
        }, {
          path: '/qc/newModel/newModel_behaviorModule',
          name: '行为模型',
          component: () => import('@/views/qc/businessModeling/newModel_behaviorModule')
        }]
      }, {
        path: '/qc/businessModeling/modelManagement',
        name: '模型管理',
        component: () => import('@/views/qc/businessModeling/modelManagement')
      }
    ]
  }, {
    path: '/qc/serviceManage',
    name: '业务管理',
    component: () => import('@/views/qc/serviceManage/index'),
    children: [
      {
        path: '/qc/serviceManage/behaviorSettings',
        name: '行为设置',
        component: () => import('@/views/qc/serviceManage/behaviorSettings')
      }, {
        path: '/qc/serviceManage/semanticManagement',
        name: '语义管理',
        component: () => import('@/views/qc/serviceManage/semanticManagement')
      }
    ]
  }, {
    path: '/qc/serviceManage/qcTask',
    name: '质检任务',
    component: () => import('@/views/qc/serviceManage/qcTask')
  }, {
    path: '/qc/qcPlan',
    name: '质检方案',
    component: () => import('@/views/qc/serviceManage/qcPlan')
  }, {
    path: '/qc/analysisReport',
    name: '质检明细报表',
    component: () => import('@/views/qc/analysisReport/index'),
    children: [{
      path: '/qc/analysisReport/qcDetailReport',
      name: '质检明细报表',
      component: () => import('@/views/qc/analysisReport/qcDetailReport')
    }, {
      path: '/qc/analysisReport/qcRealTimeReport',
      name: '实时质检报表',
      component: () => import('@/views/qc/analysisReport/qcRealTimeReport')
    }]
  }, {
    path: '/qc/qcReport',
    name: '质检报告',
    component: () => import('@/views/qc/analysisReport/qcReport')
  },
  {
    path: '/qc/qcReview',
    name: '质检复核',
    component: () => import('@/views/qc/qcReview/index')
  }

]
export default qcRoutes
